import moment from 'moment';
import 'antd/dist/antd.css';
import HostFooter from './HostFooter';
import { Modal, Popover, notification, Button, Radio, Checkbox, Icon, Tag, Spin } from 'antd';
import { push } from 'connected-react-router';
import React, { useState, useEffect } from 'react';
import edit from '../../assets/images/host/edit.svg';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Cell, DialogContainer } from 'react-md';
import { getvaluesfromURL } from '../../helper/Filter';
import UnifiedHostCalendar from './UnifiedHostCalendar';
import UnifiedCalendarDetailsModal from './Modals/UnifiedCalendarDetailsModal';
import { CREATE, EDIT, ADMIN } from '../Common/constants';
import { SPACE_STATUS } from './HostDashboardActionTypes';
import deleteIcon from '../../assets/images/host/delete.svg';
import { tick } from '../Common/Images';
import google from '../../assets/images/space-listing/google.png';
import useWindowDimensions from '../Common/Hooks/useWindowDimensions';
import CreateReservationModal from './Modals/CreateReservationModal';
import useAuth from '../../hooks/useAuth';
import { CALENDER_DISPLAY_DATE_FORMAT, CALENDER_DATE_FORMAT, IMAGES_BASE_URL, scopes, updated_scopes, updated_client_id, REDIRECT_URL } from '../../settings';
import {
  fetchSpaceDetails,
  getCalenderData,
  createReservation,
  sendBookingCancellation,
  sendAdminBookingCancellation,
  fetchSelectedBooking,
  updateReservation,
  getCalenderList,
  checkUserAuthorization,
  calendarAddToSpace,
  getLoggedUserStatus,
  removeGoogleCalenderFromSpace,
  setSelectedCalendar,
  getCalenderVisitsData,
  updateVisitStatus,
  createAndAssignCalendar,
} from './HostDashboardActions';
import { CLEAR_SPACE_AVAILABILITY, CLEAR_CALENDAR_DATA } from './HostDashboardActionTypes';
import { redClose } from '../BookingCancelation/BookingCancellationAssets';
import { endDate, startDate } from '../../helper/HostDashboardHelper';
import { useParams } from 'react-router-dom';
import GoogleLogin from 'react-google-login';
import SpaceManagementLayout from './SpaceManagementLayout';
import { alertSuccess, alertError } from '../../helper/AlertNotification';
import { tentativeBookingConfirm, releaseTentativeBooking } from '../Booking/BookingAction';

const SCOPES = updated_scopes;
const CLIENT_ID = updated_client_id;
const REDIRECT_URI = REDIRECT_URL;

const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

const Calendar = () => {
  const { user: loggedUser } = useAuth();
  const isAdmin = loggedUser && loggedUser.authorities && (loggedUser.authorities[0] === ADMIN);
  const [visibleModel, setHelpAndSupportVisible] = useState(false);
  const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
  const [isAssignModalVisible, setIsAssignModalVisible] = useState(false);
  const [isUnLinkModalVisible, setIsUnlinkModalVisible] = useState(false);
  const [isGoogleModalVisible, setIsGoogleModalVisible] = useState(false);
  const [isCreatingCalendar, setIsCreatingCalendar] = useState(false);
  const [isCalendarLoading, setIsCalendarLoading] = useState(false);
  const [showAll, setShowAll] = useState(true);
  const [showReservations, setShowReservations] = useState(true);
  const [showVisits, setShowVisits] = useState(true);
  const dispatch = useDispatch();
  const dimensions = useWindowDimensions();
  const searchURLstring = useSelector((state) => state?.router?.location?.search || '');
  const authStatus = useSelector((state) => state?.hostDashboard?.calendar?.authStatus || EMPTY_OBJECT);
  const calendarListObj = useSelector((state) => state?.hostDashboard?.calendar?.calendarList || EMPTY_OBJECT);
  const calendarList = Object.values(calendarListObj);
  const { spaceId, status } = getvaluesfromURL(searchURLstring);
  const calenderData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.bookings || EMPTY_OBJECT);
  const visitsData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.schedulers || EMPTY_OBJECT);
  const spaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || EMPTY_OBJECT);
  const selectedSpaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || null);

  // Determine if booking type requires restriction
  let isRequestToBook = false;
  if (spaceDetails && 'instanceBookingAvailability' in spaceDetails) {
    isRequestToBook = !spaceDetails.instanceBookingAvailability;
  } else if (spaceDetails?.bookingType === 'REQUEST' || spaceDetails?.bookingType === 'REQUEST_TO_BOOK') {
    isRequestToBook = true;
  }

  const createReservationStatus = useSelector((state) => state?.hostDashboard?.data?.createReservation || null);
  const cancelReservationStatus = useSelector((state) => state?.hostDashboard?.data?.cancelReservation || null);
  const updateReservationStatus = useSelector((state) => state?.hostDashboard?.data?.updateReservation || null);
  const category = useSelector(
    (state) =>
      state?.hostDashboard?.data?.spaceDetails?.events &&
      state?.hostDashboard?.data?.spaceDetails?.events.length > 0 &&
      state?.hostDashboard?.data?.spaceDetails?.events[0]?.eventType?.spaceCategory?.name
  );
  const [createReservationVisibility, setCreateReservationVisibility] = useState(false);
  const [bookingsForTheDate, setBookingsForTheDate] = useState([]);
  const [visitsForTheDate, setVisitsForTheDate] = useState([]);
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [cancelPopupVisibility, setCancelPopupVisibility] = useState(false);
  const [popOverVisibility, setPopOverVisibility] = useState([]);
  const [deleteBookingId, setDeleteBookingId] = useState(null);
  const [popupType, setPopupType] = useState('');
  const selectedSpace = useSelector((state) => state?.hostDashboard?.data?.selectedSpaceData || EMPTY_OBJECT);
  const errorMessage = useSelector((state) => state?.hostDashboard?.error);
  const [selectedDate, setSelectedDate] = useState(moment());
  const mobileView = dimensions.width < 992;
  const [displayEditBlock, setEditBlockStatus] = useState(false);
  const [isSystemBookingCancelled, setIsSystemBookingCancelled] = useState(false);
  const authToken = useSelector((state) => state?.auth?.loginDetails?.data?.token || '');
  const [showButton, setButtonActive] = useState(true);
  const { country } = useParams();
  // const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const currentCalendar = calendarList.find((calendar) => calendar.spaceId === spaceId);
  const selectedCalendar = useSelector((state) => state.hostDashboard?.calendar?.selectedCalendar || null);

  const headers = {
    'Content-Type': 'application/json',
    Authorization: authToken,
  };

  const handleCalendarSelect = (e) => {
    dispatch(setSelectedCalendar(e.target.value));
  };

  const updateSelectedCalender = () => {
    const selected = calendarList.find((calendar) => calendar.spaceId === spaceId);
    if (selected) {
      dispatch(setSelectedCalendar(selected.calendarId));
    }
  };

  // useEffect(() => {
  //   updateSelectedCalender();
  // }, []);

  const showSyncModal = () => {
    if (authStatus?.status) {
      setIsSaveModalVisible(true);
      setIsCalendarLoading(true);
      dispatch(getCalenderList((success) => {
        setIsCalendarLoading(false);
        updateSelectedCalender();
      }));
    } else {
      setPopoverVisible(true);
    }
  };
  const handleUnlinkOk = () => {
    dispatch(
      removeGoogleCalenderFromSpace(spaceId, (success) => {
        if (success) {
          dispatch(getCalenderList());
          dispatch(setSelectedCalendar(null));
          setIsUnlinkModalVisible(false);
          handleDataFetch();
          alertSuccess('Calendar Unlinked', 'Google Calendar has been removed from this space.');
        } else {
          alertError('Unlink Failed', 'Unable to unlink the calendar. Please try again.');
        }
      })
    );
  };

  const handleUnlinkCancel = () => {
    setIsUnlinkModalVisible(false);
    setIsSaveModalVisible(true);
  };

  const handleAssignedOk = () => {
    const payload = {
      spaceId: spaceId,
      calendarId: selectedCalendar,
      isActive: true,
      authTokenMapId: authStatus?.authTokenMapId,
    };

    dispatch(
      calendarAddToSpace(payload, (success) => {
        if (success) {
          dispatch(getCalenderList());
          handleDataFetch();
          setIsAssignModalVisible(false);
          setIsSaveModalVisible(false);
          alertSuccess('Calendar Assigned', 'Selected Google Calendar is now synced with this space.');
        } else {
          alertError('Assignment Failed', 'Remove the previous calendar before adding a new one.');
        }
      })
    );
  };

  const handleAssignCancel = () => {
    setIsAssignModalVisible(false);
    setIsSaveModalVisible(true);
  };

  const handleAutoCreateAndAssignCalendar = () => {
    setIsCreatingCalendar(true);
    const payload = {
      spaceId: spaceId
    };
    const calendarName = `MillionSpaces - ${spaceDetails?.spaceName}`;
    dispatch(createAndAssignCalendar(payload, calendarName, (success, res) => {
      setIsCreatingCalendar(false);
      if (success) {
        setIsSaveModalVisible(false);
        dispatch(getCalenderList());
        dispatch(checkUserAuthorization(spaceId));
        handleDataFetch();
        alertSuccess('Success', 'New Google Calendar created and assigned to this space!');
      } else {
        alertError('Creation Failed', 'Failed to auto-create calendar. Please try manual assignment.');
      }
    }));
  };

  const handleDataFetch = (date = selectedDate) => {
    const startRange = moment(date).startOf('month').subtract(1, 'month').format(CALENDER_DATE_FORMAT);
    const endRange = moment(date).add(3, 'months').endOf('month').format(CALENDER_DATE_FORMAT);
    const payload = {
      startDate: startRange,
      endDate: endRange,
    };
    dispatch(getCalenderVisitsData(spaceId, payload));
    dispatch(getCalenderData(spaceId, payload, headers));
  };

  const visitUpdateNotification = (status, visitName, actionType) => {
    if (status) {
      const message = actionType === 'ACCEPT'
        ? `${visitName}'s visit has been approved.`
        : `${visitName}'s visit has been declined.`;
      alertSuccess(actionType === 'ACCEPT' ? 'Visit Approved' : 'Visit Declined', message);
    } else {
      alertError('Visit Update Failed', 'Failed to update visit status. Please try again.');
    }
  };

  const handleAcceptVisit = (visit) => {
    const { schedulerId: id, firstName, lastName } = visit;
    const visitName = `${firstName} ${lastName}`;
    const notificationCallback = (status) => visitUpdateNotification(status, visitName, 'ACCEPT');
    dispatch(updateVisitStatus({ id, schedulerStatus: SPACE_STATUS.ACTIVE }, handleDataFetch, notificationCallback));
  };

  const handleDeclineVisit = (visit) => {
    const { schedulerId: id, firstName, lastName } = visit;
    const visitName = `${firstName} ${lastName}`;
    const notificationCallback = (status) => visitUpdateNotification(status, visitName, 'DECLINE');
    dispatch(updateVisitStatus({ id, schedulerStatus: SPACE_STATUS.INACTIVE }, handleDataFetch, notificationCallback));
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    const dateString = date.format('DD-MM-YYYY');

    // Get Bookings
    const bookings = calenderData[dateString] || [];

    // Get Visits
    let visits = [];
    if (visitsData && Object.keys(visitsData).length) {
      // Check if keyed by date directly
      if (visitsData[dateString]) {
        visits = visitsData[dateString];
      } else {
        // Fallback based on logic from ManageVisits.js
        visits = Object.values(visitsData).flatMap(i => i).filter(item => item.schedulerStartDate === dateString);
      }
    }

    // If no bookings or visits, open Create Reservation modal directly
    if (bookings.length === 0 && visits.length === 0) {
      //setPopupType(CREATE);
      //setCreateReservationVisibility(true);
      return;
    }

    setBookingsForTheDate(bookings);
    setVisitsForTheDate(visits);
    setDetailsModalVisible(true);
  };

  const handlePanelChange = (date) => {
    setSelectedDate(date);
    handleDataFetch(date);
  };

  const handleEditBooking = (booking) => {
    setPopupType(EDIT);
    dispatch(fetchSelectedBooking(booking.id, headers));
    setEditBlockStatus(true);
  };

  const handleCancelBooking = (booking) => {
    if (booking?.platformIdentity === 'SYSTEM_BOOKING') {
      setIsSystemBookingCancelled(true);
      const payload = { bookingId: booking.id };
      dispatch(sendAdminBookingCancellation(payload, headers));
    } else {
      setIsSystemBookingCancelled(false);
      const payload = { id: booking.id };
      dispatch(sendBookingCancellation(payload, headers));
    }
  };

  const openConfirmNotification = (status) => {
    notification.open({
      className: 'booking-cancellation-notification',
      message: (
        <span className="title">
          <img src={status ? tick : redClose} alt="arrow" className="icon" />
          <span className="text">{status ? 'Booking confirmed!' : 'Booking confirmation Failed!'}</span>
        </span>
      ),
      duration: 2,
      description: status ? 'You have successfully confirmed the booking.' : 'Booking confirmation failed. Please try again',
    });
    if (status) {
      setTimeout(() => {
        handleDataFetch();
      }, 1500);
    }
  };

  const openReleaseNotification = (status) => {
    notification.open({
      className: 'booking-cancellation-notification',
      message: (
        <span className="title">
          <img src={status ? tick : redClose} alt="arrow" className="icon" />
          <span className="text">{status ? 'Booking released!' : 'Booking release Failed!'}</span>
        </span>
      ),
      duration: 2,
      description: status ? 'You have successfully released the booking.' : 'Booking release failed. Please try again',
    });
    if (status) {
      handleDataFetch();
    }
  };

  const handleConfirmBooking = (booking) => {
    dispatch(tentativeBookingConfirm(booking.id, openConfirmNotification));
  };

  const handleReleaseBooking = (booking) => {
    dispatch(releaseTentativeBooking(booking.id, openReleaseNotification));
  };

  useEffect(() => {
    dispatch(fetchSpaceDetails(spaceId));
    dispatch(checkUserAuthorization(spaceId));
  }, []);

  useEffect(() => {
    if (authStatus?.status) {
      dispatch(getCalenderList());
    }
  }, [authStatus?.status, dispatch]);

  useEffect(() => {
    bookingsForTheDate.length &&
      bookingsForTheDate.forEach((booking) => {
        popOverVisibility.push(false);
      });
  }, [bookingsForTheDate]);

  useEffect(() => {
    if (selectedDate) {
      const dateString = selectedDate.format('DD-MM-YYYY');

      const bookings = calenderData?.[dateString] || [];
      setBookingsForTheDate(bookings);

      let visits = [];
      if (visitsData && Object.keys(visitsData).length) {
        if (visitsData[dateString]) {
          visits = visitsData[dateString];
        } else {
          visits = Object.values(visitsData).flatMap(i => i).filter(item => item.schedulerStartDate === dateString);
        }
      }
      setVisitsForTheDate(visits);
    }
  }, [calenderData, visitsData, selectedDate]);

  useEffect(() => {
    const startMonth = moment().startOf('month').format(CALENDER_DATE_FORMAT);
    const endMonth = moment().add(3, 'months').format(CALENDER_DATE_FORMAT);
    const payload = {
      startDate: startMonth,
      endDate: endMonth,
    };
    try {
      if (authToken) {
        dispatch(
          getCalenderData(spaceId, payload, headers)
        );
        dispatch(getCalenderVisitsData(spaceId, payload));
      }
    } catch (error) {
      throw error
    }
  }, [authToken, createReservationStatus, updateReservationStatus, cancelReservationStatus, spaceId]);

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_CALENDAR_DATA });
    }
  }, [spaceId]);

  useEffect(() => {
    if (createReservationStatus) {
      if (createReservationStatus.status === 'SUCCESS') {
        alertSuccess('Reservation Created', 'The reservation has been created successfully.');
      } else if (createReservationStatus.status === 'FAILURE') {
        alertError('Creation Failed', 'Failed to create the reservation. Please try again.');
      }
    }
  }, [createReservationStatus]);

  useEffect(() => {
    if (updateReservationStatus) {
      if (updateReservationStatus.status === 'SUCCESS') {
        alertSuccess('Reservation Updated', 'The reservation has been updated successfully.');
      } else if (updateReservationStatus.status === 'FAILURE') {
        alertError('Update Failed', 'Failed to update the reservation. Please try again.');
      }
    }
  }, [updateReservationStatus]);

  const handleCreateReservation = () => {
    setPopupType(CREATE);
    setCreateReservationVisibility(true);
  };

  const handleModalCancel = () => {
    setCreateReservationVisibility(false);
    dispatch({ type: CLEAR_SPACE_AVAILABILITY });
  };

  const handleProceedReservation = (payload) => {
    if (popupType === CREATE) {
      dispatch(createReservation(payload, headers));
    } else {
      const editingHeaders = {
        'Content-Type': 'application/json',
        Authorization: authToken,
        'If-Match': selectedSpace?.version || '',
      };
      dispatch(updateReservation(payload, editingHeaders));
    }
    setCreateReservationVisibility(false);
  };

  const handlePopoverVisibleChange = (index, visible) => {
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = visible;
    setPopOverVisibility([...visibilityArray]);
  };

  const handleEditReservation = (id, index) => {
    setPopupType(EDIT);
    dispatch(fetchSelectedBooking(id, headers));
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = false;
    setPopOverVisibility([...visibilityArray]);
  };

  const handleCancelReservation = (id, index) => {
    const visibilityArray = popOverVisibility;
    visibilityArray[index] = false;
    setPopOverVisibility([...visibilityArray]);
    setDeleteBookingId(id);
    dispatch(fetchSpaceDetails(spaceId));
    setCancelPopupVisibility(true);
  };

  const handleCancelReservationYes = () => {
    setIsSystemBookingCancelled(false);
    const payload = { id: deleteBookingId };
    dispatch(sendBookingCancellation(payload, headers));
    setCancelPopupVisibility(false);
  };

  useEffect(() => {
    if (cancelReservationStatus) {
      if (cancelReservationStatus.status === 'SUCCESS') {
        if (isSystemBookingCancelled) {
          alertSuccess('Booking Cancelled', 'The booking has been cancelled successfully.');
        } else {
          alertSuccess('Reservation Cancelled', 'The reservation has been cancelled successfully.');
        }
      } else if (cancelReservationStatus.status === 'FAILURE') {
        if (isSystemBookingCancelled) {
          alertError('Cancellation Failed', 'Failed to cancel the booking. Please try again.');
        } else {
          alertError('Cancellation Failed', 'Failed to cancel the reservation. Please try again.');
        }
      }
    }
  }, [cancelReservationStatus, isSystemBookingCancelled]);

  const handleCancelReservationNo = () => {
    setCancelPopupVisibility(false);
  };

  const handleReservation = (bookingId, index) => {
    handleEditReservation(bookingId, index);
    setEditBlockStatus(true);
  };

  const content = (booking, index) => {
    return (
      <div className="reservation-popover">
        <span className="list-items" onClick={() => handleReservation(booking.id, index)}>
          <img src={edit} alt="img" className="icon" />
          Edit reservation
        </span>
        <span className="list-items cancel" onClick={() => handleCancelReservation(booking.id, index)}>
          <img src={deleteIcon} alt="img" className="icon" />
          Cancel reservation
        </span>
      </div>
    );
  };

  useEffect(() => {
    if (selectedSpace.length !== 0 && displayEditBlock) {
      setCreateReservationVisibility(true);
    }
  }, [selectedSpace]);

  const handleEnteredBookingData = () => {
    if (popupType === EDIT) {
      return {
        startingDate: selectedSpace?.bookingStartDate || '',
        endingDate: selectedSpace?.bookingEndDate || '',
        firstName: selectedSpace?.reservationDetails?.firstName || '',
        lastName: selectedSpace?.reservationDetails?.lastName || '',
        email: selectedSpace?.reservationDetails?.email || '',
        contact: selectedSpace?.reservationDetails?.contactNumber || '',
        title: selectedSpace?.title || '',
        description: selectedSpace?.description || '',
        guestCount: selectedSpace?.guest || 0,
        seatingArrangement: selectedSpace?.seatArrangement?.name || '',
        startTime: selectedSpace?.pricingOptions?.[0]?.startTime || '',
        endTime: selectedSpace?.pricingOptions?.[0]?.endTime || '',
        blocks: selectedSpace?.pricingOptions || [],
      };
    } else {
      return {
        startingDate: '',
        endingDate: '',
        firstName: '',
        lastName: '',
        email: '',
        contact: '',
        title: '',
        description: '',
        guestCount: 1,
        seatingArrangement: '',
        startTime: '',
        endTime: '',
        blocks: [],
      };
    }
  };

  useEffect(() => {
    if (errorMessage && errorMessage?.status !== 404) {
      alertError('Error Occurred', 'An error occurred while processing your request. Please try again.');
    }
  }, [errorMessage]);

  const handleBackToCurrentDate = () => {
    const currentDate = moment().format('YYYY-MM-DD');
    setSelectedDate(moment(currentDate));
  };

  const handleShowAllChange = (e) => {
    const checked = e.target.checked;
    setShowAll(checked);
    setShowReservations(checked);
    setShowVisits(checked);
  };

  const handleShowReservationsChange = (e) => {
    const checked = e.target.checked;
    setShowReservations(checked);
    setShowAll(checked && showVisits);
  };

  const handleShowVisitsChange = (e) => {
    const checked = e.target.checked;
    setShowVisits(checked);
    setShowAll(checked && showReservations);
  };

  useEffect(() => {
    if (isRequestToBook) {
      setShowAll(false);
      setShowReservations(false);
      setShowVisits(true);
    }
  }, [isRequestToBook]);

  useEffect(() => {
    const selected = moment(selectedDate).format('YYYY-MM-DD');
    const isInBetween = moment(selected).isBetween(moment(endDate), moment(startDate));
    if (isInBetween) setButtonActive(true);
    else setButtonActive(false);
  }, [selectedDate]);

  const responseGoogle = (response) => {
    if (response.code) {
      const payload = {
        code: response?.code
      }
      dispatch(
        getLoggedUserStatus(payload, (success, res) => {
          if (success) {
            dispatch(getCalenderList());
            dispatch(checkUserAuthorization(spaceId));
            setPopoverVisible(false);
            setIsSaveModalVisible(true);
            alertSuccess('Calendar Synced', 'Your Google Calendar connection is active.');
          } else {
            alertError('Calendar Sync Failed', res.data ? res.data : 'Calendar sync was unsuccessful.');
          }
        })
      );
    }
  };

  const responseError = (error) => {
    alertError('Calendar Sync Failed', 'Calendar sync was unsuccessful.');
  };

  return (
    <SpaceManagementLayout activeTab="2">
      <div className="my-calendar host-dashboard">

        <div className="filter-header">
          <div className="filter-header-content">
            <div className="filters">
              {!isRequestToBook && <Checkbox checked={showAll} onChange={handleShowAllChange}>All</Checkbox>}
              {!isRequestToBook && <Checkbox checked={showReservations} onChange={handleShowReservationsChange}>Reservations</Checkbox>}
              <Checkbox checked={showVisits} onChange={handleShowVisitsChange} disabled={isRequestToBook}>Visits</Checkbox>
            </div>

            <div className="right-actions no-flex-wrap">
              {!isRequestToBook && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Popover
                    placement="bottomLeft"
                    title="Calendar Sync Information"
                    content={
                      <div style={{ maxWidth: '300px', fontSize: '12px', color: '#333' }}>
                        <p><b>Google Workspace Account (Recommended)</b><br />
                          Create separate rooms/resources for each space and select the correct room when syncing for accurate management.</p>
                        <p style={{ marginTop: '10px' }}><b>Personal Gmail (Alternative)</b><br />
                          If you're using a personal email, you can create multiple calendars in Google Calendar, assign one calendar per space, and sync each accordingly.</p>
                        <p style={{ marginTop: '10px', color: '#FF0054' }}><b>NEW: One-Click Setup</b><br />
                          Choose "Create New Dedicated Calendar" after syncing to automatically set up a new calendar for your space!</p>
                      </div>
                    }
                    trigger="click"
                  >
                    <Icon type="question-circle" style={{ color: '#999', fontSize: '14px', cursor: 'help' }} />
                  </Popover>
                  <button
                    onClick={() => showSyncModal()}
                    className={`goglesync-btn ${authStatus?.status ? 'goglesync-btn-green' : 'goglesync-btn-gray'}`}
                  >
                    <img src={google} alt="google" className="google-icon" />
                    <span className="btn-text">{authStatus?.status ? 'Synced' : 'Sync Calendar'}</span>
                  </button>
                </div>
              )}
              {!isRequestToBook && (
                <button className="btn-yellow btn-reservation" onClick={handleCreateReservation}>
                  <Icon type="plus" className="reservation-icon" />
                  <span className="btn-text">Create Reservation</span>
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="content scrollwrap">
          <div className="calendar-wrapper-padding">
            <UnifiedHostCalendar
              bookings={showReservations && !isRequestToBook ? calenderData : {}}
              visits={showVisits ? visitsData : {}}
              selectedDate={selectedDate}
              onSelectDate={handleDateSelect}
              onPanelChange={handlePanelChange}
              spaceTitle={spaceDetails?.spaceName}
              mobileView={mobileView}
            />
          </div>
          <UnifiedCalendarDetailsModal
            visible={detailsModalVisible}
            onCancel={() => setDetailsModalVisible(false)}
            date={selectedDate}
            bookings={bookingsForTheDate}
            visits={visitsForTheDate}
            onEditBooking={handleEditBooking}
            onCancelBooking={handleCancelBooking}
            onConfirmBooking={handleConfirmBooking}
            onReleaseBooking={handleReleaseBooking}
            onAcceptVisit={handleAcceptVisit}
            onDeclineVisit={handleDeclineVisit}
            isAdmin={isAdmin}
            cancellationPolicy={spaceDetails?.cancellationPolicy || (spaceDetails?.events && spaceDetails.events[0]?.cancellationPolicy)}
          />
        </div>
        <Modal
          className="host-dashboard-modal create-reservation-modal"
          visible={createReservationVisibility}
          onCancel={handleModalCancel}
          footer={null}
          destroyOnClose={true}
        >
          <CreateReservationModal
            setVisible={setCreateReservationVisibility}
            space={spaceDetails}
            onProceed={handleProceedReservation}
            selectedSpaceDetails={selectedSpaceDetails}
            blockType={popupType}
            previousBookingData={handleEnteredBookingData()}
            selectedDateOnCalender={selectedDate}
            category={category}
          />
        </Modal>

        <Modal
          centered
          title={
            <div className="header-container-calnder">
              <div className="google-container">
                <div>
                  <img alt="img" className="img-google" src={google} />
                </div>

                <div className="google-container-col">
                  <p className="google-text">Google Calendar</p>
                  <a className={`authorized-text ${!(currentCalendar && selectedCalendar === currentCalendar.calendarId) ? 'disabled' : ''}`} onClick={() => { setIsSaveModalVisible(false); setIsUnlinkModalVisible(true); }}>Unlink calendar from the space</a>

                </div>
              </div>

            </div>
          }
          // wrapClassName="custom-ant-space-modal-calandar"  // this style for sync modal and  custom-ant-space-modal-calandar this is common style for botth sync and async modl and if async true custom-ant-space-modal-calandar-resync this style should be apply
          wrapClassName=' custom-ant-space-modal-calandar '//this style for async modl
          visible={isSaveModalVisible}
          onCancel={() => setIsSaveModalVisible(false)}
          footer={[
            <Button key="cancel"
              onClick={() => setIsSaveModalVisible(false)}
              className="custom-cancel-button-assign">
              Cancel
            </Button>,
            <Button
              key="ok"
              onOk={() => setIsSaveModalVisible(false)}
              className="assign-button assign-btn-async"
              onClick={() => { setIsSaveModalVisible(false); setIsAssignModalVisible(true); }}
              disabled={!selectedCalendar || (currentCalendar && selectedCalendar === currentCalendar.calendarId)}
              style={{ opacity: !selectedCalendar || (currentCalendar && selectedCalendar === currentCalendar.calendarId) ? 0.5 : 1 }}
            >
              Assign to This Space
            </Button>,
          ]}
        >
          <div className="calendar-sync-options">
            {isCalendarLoading ? (
              <div className="calendar-loading-container">
                <Spin indicator={<Icon type="loading" spin />} tip="Fetching calendars..." />
              </div>
            ) : (
              <>
                {(!currentCalendar && !(calendarList && calendarList.some(calendar => calendar.name?.trim().toLowerCase() === `MillionSpaces - ${spaceDetails?.spaceName}`.trim().toLowerCase()))) && (
                  <div className="auto-create-section">
                    <p className="section-title">Fastest Setup</p>
                    <Button
                      type="primary"
                      onClick={handleAutoCreateAndAssignCalendar}
                      loading={isCreatingCalendar}
                      className="auto-create-btn"
                    >
                      Create New Dedicated Calendar
                    </Button>
                    <p className="helper-text">
                      We'll create a new calendar named <b>"MillionSpaces - {spaceDetails?.spaceName}"</b> for you.
                    </p>
                  </div>
                )}

                {(!currentCalendar && !(calendarList && calendarList.some(calendar => calendar.name?.trim().toLowerCase() === `MillionSpaces - ${spaceDetails?.spaceName}`.trim().toLowerCase()))) ? (
                  <p className="section-title">Or Select Existing</p>
                ) : (
                  <p className="section-title">Select Google Calendar</p>
                )}
                <Radio.Group onChange={handleCalendarSelect} value={selectedCalendar} className="radio-group">
                  {calendarList
                    .filter((calendar) => calendar.spaceId === null || calendar.spaceId === spaceId)
                    .map((calendar) => (
                      <Radio key={calendar.calendarId} value={calendar.calendarId} className="radio-item">
                        <span>{calendar.name} {calendar.accessRole === 'reader' && <Tag className="read-only-tag">Read-only</Tag>}</span>
                      </Radio>
                    ))}
                </Radio.Group>
                {calendarList.find(c => c.calendarId === selectedCalendar)?.accessRole === 'reader' && (
                  <p className="sync-warning-notice">
                    <Icon type="warning" className="warning-icon" />
                    <b>Notice:</b> This calendar is read-only. MillionSpaces will import existing events, but new booking records will <b>NOT</b> be written back to this Google Calendar. For full bidirectional sync, please ensure you have "Make changes to events" permission.
                  </p>
                )}
              </>
            )}
          </div>
        </Modal>



        {popoverVisible && (
          <div className="google-sync-overlay" onClick={() => setPopoverVisible(false)}>
            <div className="google-sync-content" onClick={(event) => event.stopPropagation()}>
              <GoogleLogin
                clientId={CLIENT_ID}
                render={(btnGoogleEnable) => (
                  <button
                    type="button"
                    className="google-sync-button"
                    onClick={btnGoogleEnable.onClick}
                  >
                    <span className="google-sync-icon">
                      <img src={google} alt="Google" />
                    </span>
                    <span className="google-sync-copy">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="google-sync-heading">Sync Google Calendar</span>
                      </div>
                      <span className="google-sync-subtext">Keep reservations and visits auto-updated.</span>
                    </span>
                  </button>
                )}
                buttonText="Login"
                onSuccess={responseGoogle}
                onFailure={responseError}
                responseType="code"
                accessType="offline"
                prompt="consent"
                scope={SCOPES}
                redirectUri={REDIRECT_URI}
              />
              <p className="google-sync-caption">
                Allow MillionSpaces to create and update events directly inside your Google Calendar.
              </p>
            </div>
          </div>
        )}

        <Modal
          title="Assign Calendar?"
          wrapClassName="custom-assign-calendar-modal"
          visible={isAssignModalVisible}
          onOk={handleAssignedOk}
          onCancel={handleAssignCancel}
          okText="Assign"
          cancelText="Cancel"
          centered
          cancelButtonProps={{ className: 'custom-cancel-button-assign' }}
          okButtonProps={{ className: 'custom-assign-button-confirm' }}
        >
          <p className="modal-text-save-head">Are you sure you want to assign this calendar to this space?</p>
        </Modal>

        <Modal
          title="Unlink Calendar"
          wrapClassName="custom-unlink-calendar-modal"
          visible={isUnLinkModalVisible}
          onOk={handleUnlinkOk}
          onCancel={handleUnlinkCancel}
          okText="Unlink"
          cancelText="Cancel"
          centered
          cancelButtonProps={{ className: 'custom-cancel-button-unlink' }}
          okButtonProps={{ className: 'custom-unlink-button-confirm' }}
        >
          <p className="modal-text-save-head custom-modal-text">
            Are you sure you want to unlink your Google Calendar from <span>{spaceDetails.spaceName}.</span>
            <span> </span>This will stop event synchronization?
          </p>
        </Modal>
      </div>

      <Modal
        className="confirmation-modal cancel-reservation-modal"
        visible={cancelPopupVisibility}
        onCancel={handleCancelReservationNo}
        title="Cancel Reservation"
        centered
        footer={[
          <Button key="cancel" onClick={handleCancelReservationNo} className="btn-cancel-modal">
            Cancel
          </Button>,
          <Button key="submit" danger onClick={handleCancelReservationYes} className="btn-yes-modal">
            Yes
          </Button>,
        ]}
      >
        <p>Are you sure you want to cancel the reservation?</p>
      </Modal>

      {mobileView && <HostFooter />}
    </SpaceManagementLayout>
  );
};

export default Calendar;
